import fieldsValidate from '@/utils/validator/fieldsValidate';
import * as yup from 'yup';

const formsValidate = {
  login: yup.object().shape({
    username: fieldsValidate.username,
    password: fieldsValidate.password,
  }),
  register: yup.object().shape({
    username: fieldsValidate.username,
    password: fieldsValidate.password,
  }),
};

export default formsValidate;
